// add organization details
export const ADD_ORGANIZATION="ADD_ORGANIZATION"
export const ADD_ORGANIZATION_SUCCESS="ADD_ORGANIZATION_SUCCESS"
export const ADD_ORGANIZATION_FAILED="ADD_ORGANIZATION_FAILED"

//get organization detail
export const GET_ORGANIZATION_DETAIL="GET_ORGANIZATION_DETAIL"
export const GET_ORGANIZATION_DETAIL_SUCCESS="GET_ORGANIZATION_DETAIL_SUCCESS"
export const GET_ORGANIZATION_DETAIL_FAILED="GET_ORGANIZATION_DETAIL_FAILED"


//update organization detail
export const UPDATE_ORGANIZATION_DETAIL="UPDATE_ORGANIZATION_DETAIL"
export const UPDATE_ORGANIZATION_DETAIL_SUCCESS="UPDATE_ORGANIZATION_DETAIL_SUCCESS"
export const UPDATE_ORGANIZATION_DETAIL_FAILED="UPDATE_ORGANIZATION_DETAIL_FAILED"

//get country
export const ORGANIZATION_DETAIL_GET_COUNTRY = "ORGANIZATION_DETAIL_GET_COUNTRY"
export const ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL = "ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL"
export const ORGANIZATION_DETAIL_GET_COUNTRY_FAILED = "ORGANIZATION_DETAIL_GET_COUNTRY_FAILED"
//get state
export const ORGANIZATION_DETAIL_GET_STATE = "ORGANIZATION_DETAIL_GET_STATE"
export const ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL = "ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL"
export const ORGANIZATION_DETAIL_GET_STATE_FAILED = "ORGANIZATION_DETAIL_GET_STATE_FAILED"
//get ip location
export const ORGANIZATION_DETAIL_GET_IP_LOCATION = "ORGANIZATION_DETAIL_GET_IP_LOCATION"
export const ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL = "ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL"
export const ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED = "ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED"

//get organization list

export const ORGANIZATION_DETAIL_GET_LIST = "ORGANIZATION_DETAIL_GET_LIST"
export const ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL = "ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL"
export const ORGANIZATION_DETAIL_GET_LIST_FAILED = "ORGANIZATION_DETAIL_GET_LIST_FAILED"

// delete organization
export const ORGANIZATION_DETAIL_DELETE = "ORGANIZATION_DETAIL_DELETE"
export const ORGANIZATION_DETAIL_DELETE_SUCCESSFULL = "ORGANIZATION_DETAIL_DELETE_SUCCESSFULL"
export const ORGANIZATION_DETAIL_DELETE_FAILED = "ORGANIZATION_DETAIL_DELETE_FAILED"